import { render, staticRenderFns } from "./BroadcastCompare.vue?vue&type=template&id=0c3065f2&scoped=true&"
import script from "./BroadcastCompare.vue?vue&type=script&lang=js&"
export * from "./BroadcastCompare.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastCompare.vue?vue&type=style&index=0&id=0c3065f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3065f2",
  null
  
)

export default component.exports